import { createFileRoute } from "@tanstack/react-router";
import { ConsumerContractDeclarationForm } from "~/components/ConsumerContractDeclarationForm";

export const Route = createFileRoute("/widerruf")({
  head: () => ({
    meta: [
      { title: "Vertrag widerrufen | Alchema" },
      { name: "description", content: "Submit and save an electronic withdrawal declaration for an Alchema subscription." },
    ],
  }),
  component: WithdrawalRoute,
});

function WithdrawalRoute() {
  return <ConsumerContractDeclarationForm mode="withdrawal" />;
}
